import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Model } from 'src/app/shared/models/clux/model-legacy';

@Component({
  selector: 'app-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [],
})
export class DropdownComponent<T> implements OnChanges {
  @Input() public data: Model.DropdownData<T>;
  @Input() public setSelectedOption: T;
  @Output() public selectedOpt = new EventEmitter<T>();
  public dropdownData: Model.DropdownData<T>;
  public optionVisibility: boolean;
  public selectedOption: T;

  /**
   * @param targetElement is the clicked target element
   * detects the document click to hide the dropdown option
   */
  @HostListener('document:click', ['$event.target'])
  public onClick(targetElement: HTMLElement): boolean {
    if (
      targetElement.classList.contains('ddl-wrapper') ||
      targetElement.classList.contains('ddl-value') ||
      targetElement.parentElement.classList.contains('ddl-value') ||
      targetElement.classList.contains('icon-dropdown') ||
      targetElement.parentElement.classList.contains('ddl-wrapper')
    ) {
      return false;
    } else {
      this.optionVisibility = false;
    }
  }

  public ngOnChanges(change: SimpleChanges): void {
    if (change.data?.currentValue) {
      this.dropdownData = this.data;
      const rawValue = sessionStorage.getItem('selectedYear');
      let selectedYear: T;
      if (rawValue && rawValue !== 'undefined') {
        selectedYear = JSON.parse(rawValue);
      }

      if (this.data.selected >= 0) {
        this.selectedOption = this.dropdownData.option[this.data.selected];
      } else {
        this.selectedOption = selectedYear === null ? this.dropdownData.option[0] : selectedYear;
      }
    }
    if (change.setSelectedOption && this.setSelectedOption) {
      this.selectedOption = this.setSelectedOption;
    }
  }

  public onChange(option: T): void {
    this.selectedOption = option;
    this.selectedOpt.emit(option);
  }
}
